export default "__VITE_ASSET__BU8lTznL__"